/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect} from 'react'
import {useAuth} from '../../../../app/modules/auth'
import {useState} from 'react'
import {useDispatch} from 'react-redux'
import {_getFacilityPods} from '../../../../state/V2/facility/facility.actions'
import {PodSelection} from '../../../layout/components/PodSelection'
import {_getFacilities} from '../../../../state/V2/facility/facility.actions'
import {AppDispatch, RootState} from '../../../../state/store'
import {useSelector} from 'react-redux'
import {_logout} from '../../../../state/V2/authentication/authentication.actions'
import {_getUserPods} from '../../../../state/V2/users/users.actions'
import {NavLink} from 'react-router-dom'

const HeaderUserMenu: FC = () => {
  const dispatch = useDispatch<AppDispatch>()
  const [open, setOpen] = useState<boolean>(false)
  const {currentUser, logout} = useAuth()
  const facilityId = useSelector((state: RootState) => state.facility.current.data?.id)

  useEffect(() => {
    dispatch(_getUserPods())
    dispatch(_getFacilities())
    if (facilityId) dispatch(_getFacilityPods({facilityId}))
  }, [dispatch, facilityId])

  const _clearState = () => {
    dispatch(_logout())
    logout()
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold w-275px py-4'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5 text-base'>
              {currentUser?.firstName} {currentUser?.lastName}
            </div>
            <a
              href={`mailto:${currentUser?.email}`}
              className='fw-bold text-muted text-hover-primary fs-7'
            >
              {currentUser?.email}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <NavLink className='menu-link text-sm' to={`/user-profile/${currentUser?.id}`}>
          Profile
        </NavLink>
      </div>
      <div className='menu-item px-5'>
        <a
          onClick={() => {
            setOpen(true)
          }}
          className='menu-link text-sm'
        >
          Pod Selection
        </a>
      </div>

      <PodSelection isShown={open} setIsShown={setOpen} />

      <div className='menu-item px-5'>
        <a onClick={_clearState} className='menu-link px-5 text-sm'>
          Sign Out
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
